<template>
  <q-page
    class="page column no-wrap items-stretch justify-between relative-position"
    :class="{ 'fixed-full': $register || (checkoutData.stepTitle === $t('checkout.steps.seats') && checkoutData.showCheckoutFooter) }"
    style="
      margin-left: auto;
      margin-right: auto;
      min-height: unset;
      width: 100%;
    "
    :style="{
      'margin-bottom': $kiosk || $isLandscapeView() || !checkoutData.showCheckoutFooter ? '0px' : '70px',
      'margin-top': topMargin,
      'max-width': $isLandscapeView() ? `${pageMaxWidth}px` : undefined
    }"
  >
    <login-and-guest-checkout-card
      v-if="!loggedIn && !guestCheckoutConfirmed && !loggedInStatus && !currentSite.consumerConfig.showTicketFirstCheckoutFlow"
      :showing="showing"
      @movie-selected="movie => selectMovie(movie)"
      @login-success="logInUser"
      @continue-as-guest="continueAsGuest"
    />

    <template v-else>
      <q-card
        v-if="showing.loaded && !currentSite.consumerConfig.showTicketFirstCheckoutFlow"
        class="bg-transparent"
        :class="{ 'no-pointer-events': showTicketSelection }"
        flat
      >
        <q-card-section class="q-pa-sm">
          <movie-card
            v-if="!$isLandscapeView()"
            :class="$q.screen.xs ? undefined : 'q-mx-auto'"
            :showing="showing"
            :movie="showing.movie"
            @movie-selected="movie => selectMovie(movie)"
          />
        </q-card-section>
        <q-card-section
          v-if="($q.screen.lt.sm || !$isLandscapeView())"
          class="no-padding"
        >
          <q-scroll-area
            :thumb-style="thumbStyle"
            style="height: 50px; z-index: 1; max-width: 100%;"
          >
            <current-showing-date-showings
              :showing="showing"
              no-wrap
            />
          </q-scroll-area>
        </q-card-section>
      </q-card>
      <div
        v-if="showing.loading"
      >
        <q-spinner
          class="fixed-center"
          size="5.5em"
        />
      </div>
      <component
        :is="showFullScreen ? 'q-dialog' : 'div'"
        v-else
        ref="seatChartContainer"
        v-model="showFullScreen"
        class="relative-position col column no-wrap items-stretch"
        :class="showFullScreen ? 'default-background' : undefined"
        maximized
        :transition-show="$q.screen.lt.sm ? 'slide-up' : undefined"
        :transition-hide="$q.screen.lt.sm ? 'slide-down' : undefined"
        data-testid="seat-chart-container"
      >
        <legend-seats
          v-if="showFullScreen || ($q.screen.gt.xs && $isLandscapeView())"
          ref="seatChartLegend"
          class="col-auto full-width"
          :class="showFullScreen? 'q-pt-lg q-px-sm default-background' : 'q-pt-xs bg-transparent'"
          :seat-chart-configuration="seatChartForShowing.seatChartConfiguration"
          :initial-selected-seats="initialSelectedSeats"
          :seat-chart="seatChartForShowing"
          :seat-preferences="seatPreferences"
        />

        <template v-if="currentScale === initialScale && showPinchZoomAnimation">
          <pinch-zoom-animation
            v-if="$q.platform.has.touch || $kiosk"
          />
          <scroll-zoom-animation
            v-else
          />
        </template>

        <pinch-scroll-zoom
          v-if="!seatChartForShowing.loading && !reloading"
          ref="zoomer"
          :class="showFullScreen ? 'overflow-hidden default-background' : 'col full-width bg-transparent'"
          key-actions
          key-controls
          :within="false"
          :scale="initialScale"
          :origin-x="originX"
          :origin-y="originY"
          :min-scale="initialMinScale"
          :max-scale="maxScale"
          :wheel-velocity="0.1"
          @scaling="e => onEvent('scaling', e)"
          @stop-drag="e => onEvent('stopDrag', e)"
          @start-drag="e => onEvent('startDrag', e)"
        >
          <seat-chart
            ref="seatChart"
            :screen-name="showing.screen.name"
            :seat-chart="seatChartForShowing"
            :seat-chart-configuration="seatChartForShowing.seatChartConfiguration"
            :show-seat-numbers="currentSite.consumerShowReservedSeatLabels"
            :hide-unavailable-seat-numbers="true"
            :has-marathon="showing && showing.hasMarathon"
            :ticket-type-id="ticketTypeId"
            :initial-selected-seats="initialSelectedSeats"
            :auto-select-seats="$register || currentSite.consumerConfig.showTicketFirstCheckoutFlow"
            :seats-to-select="currentSite.consumerConfig.showTicketFirstCheckoutFlow ? seatsToSelect : undefined"
            :seat-preferences="seatPreferences"
            :show-footer="false"
            :show-header="false"
            :is-full-screen="showFullScreen"
            :container-width="showFullScreen && $q.screen.gt.xs ? containerWidth : pageMaxWidth"
            :emit-seat-objects="!currentSite.consumerConfig.showTicketFirstCheckoutFlow"
            @update:model-value="(input) => handleSeatChartInput(input)"
            @error="error => hasSeatChartError = !!error"
          />
        </pinch-scroll-zoom>

        <q-inner-loading :showing="seatChartForShowing.loading || reloading" />
        <div
          class="row q-pa-xs justify-between items-end no-pointer-events"
          style="margin-top: auto; max-height: 80px; top: auto !important;"
          :style="{ 'bottom': !$isLandscapeView() && $q.screen.gt.xs && !showFullScreen ? $kiosk ? '0' : '40px' : undefined }"
          :class=" {
            'fixed-bottom': $q.screen.gt.sm,
            'absolute-bottom': $q.screen.lt.sm || showFullScreen,
            'absolute full-width': !$isLandscapeView() && $q.screen.gt.xs && !showFullScreen
          }"
        >
          <legend-seats
            v-if="!showFullScreen && ($q.screen.lt.sm || !$isLandscapeView())"
            ref="seatChartLegend"
            class="bg-transparent all-pointer-events"
            :class="$q.screen.lt.md ? 'col-auto' : 'col q-pr-md'"
            :seat-chart-configuration="seatChartForShowing.seatChartConfiguration"
            :initial-selected-seats="initialSelectedSeats"
            :seat-chart="seatChartForShowing"
            :seat-preferences="seatPreferences"
            :button-only="$q.screen.lt.md"
          />
          <div
            v-if="selectedSeats && selectedSeats.length > 0 && showFullScreen"
            class="col-auto text-center bg-responsive q-py-xs q-px-sm borders"
          >
            <div
              class="text-left"
              style="word-break: break-all; max-width: 60vw;"
            >
              {{ $t('checkout.steps.seats') }} : <span
                class="text-responsive"
                :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder'"
              >{{ selectedSeatsString }}</span>
            </div>
          </div>
          <q-space
            v-else
            class="col"
          />
          <q-btn-group
            class="q-gutter-sm col-auto all-pointer-events"
            flat
          >
            <q-btn
              class="border-responsive-grey-1"
              :class="$q.screen.lt.sm ? 'q-pa-xs' : 'q-pa-sm'"
              color="responsive"
              dense
              text-color="responsive"
              icon="fas fa-minus"
              :disabled="initialMinScale === currentScale"
              @click="onZoomOut()"
            />
            <q-btn
              class="border-responsive-grey-1"
              :class="$q.screen.lt.sm ? 'q-pa-xs' : 'q-pa-sm'"
              color="responsive"
              dense
              text-color="responsive"
              icon="fas fa-plus"
              :disabled="currentScale >= maxScale"
              @click="onZoomIn()"
            />
            <q-btn
              class="border-responsive-grey-1"
              :class="$q.screen.lt.sm ? 'q-pa-xs' : 'q-pa-sm'"
              color="responsive"
              dense
              text-color="responsive"
              :icon="showFullScreen ? 'fal fa-minimize' : 'fas fa-expand'"
              @click="toggleFullScreen(selectedSeats)"
            />
          </q-btn-group>
        </div>
      </component>
    </template>

    <q-dialog
      v-model="showTicketSelection"
      :position="$q.screen.lt.sm ? 'bottom' : undefined"
      persistent
      data-test-id="select-tickets-dialog"
    >
      <q-card
        :style="{
          'min-height': $q.screen.lt.sm ? '60vh' : 'unset',
          'min-width': $q.screen.lt.sm ? 'unset' : '800px'
        }"
        class="bg-responsive"
      >
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">
            {{ $t('pages.selectTickets.selectYourTicket') }}
          </div>
          <q-space />
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="closeTicketSelectionWindow()"
          />
        </q-card-section>
        <q-card-section>
          <select-users
            v-if="showingForTicketSelection"
            :showing="showingForTicketSelection"
            :user="order.user"
            :selected-seat="selectedSeatString"
            show-current-selected-seat-info
            combined-ticket-selection
          />
        </q-card-section>
      </q-card>
    </q-dialog>

    <checkout-controls
      v-if="!$q.screen.lt.sm && !hideCheckoutControls && $register"
      @next="next"
    />
  </q-page>
</template>

<script>
import { Cookies } from 'quasar'
import Model from 'src/models/Model'
import { getSeatNameForTicketType, isTicketSelectionComplete, unassignedSelectedSeats } from 'src/models/order/CheckoutData'
import LegendSeats from 'src/modules/admin/seat-chart/LegendSeats'
import PinchZoomAnimation from 'src/modules/admin/seat-chart/PinchZoomAnimation'
import ScrollZoomAnimation from 'src/modules/admin/seat-chart/ScrollZoomAnimation'
import SeatChart from 'src/modules/admin/seat-chart/SeatChart'
import SeatChartMixin from 'src/modules/admin/seat-chart/SeatChartMixin'
import CheckoutControls from 'src/modules/checkout/components/CheckoutControls'
import CurrentShowingDateShowings from 'src/modules/checkout/components/CurrentShowingDateShowings'
import LoginAndGuestCheckoutCard from 'src/modules/checkout/components/LoginAndGuestCheckoutCard'
import MovieCard from 'src/modules/checkout/components/MovieCard'
import SelectUsers from 'src/modules/register/components/SelectUsers'
import { watchEffect } from 'vue'
const sortAlphaNum = (a, b) => a.localeCompare(b, 'en', { numeric: true })
export default {
  name: 'Seats',
  components: {
    SeatChart,
    CheckoutControls,
    SelectUsers,
    MovieCard,
    CurrentShowingDateShowings,
    LegendSeats,
    PinchZoomAnimation,
    ScrollZoomAnimation,
    LoginAndGuestCheckoutCard
  },
  mixins: [SeatChartMixin],
  inject: ['order', 'checkoutData'],
  context: ['currentUser', 'currentRegisterClient'],
  configuration: ['currentCircuit', 'currentSite'],
  props: {
    emitNext: {
      type: Boolean,
      default: false,
      required: false
    },
    hideCheckoutControls: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['next'],
  data () {
    return {
      saving: false,

      selectedSeats: this.checkoutData.selectedSeatsForShowingId(this.$kiosk ? this.$route.params?.showing : this.$route.params?.showingId),
      selectionDescription: null,
      selectionComplete: false,

      ticket: null,
      guestCheckoutConfirmed: this.checkoutData.guestCheckoutConfirmed,
      showingForTicketSelection: null,
      showTicketSelection: false,
      hasSeatChartError: false,
      shouldReselectSeats: false,
      loggedInStatus: false,
      showFullScreen: false,
      pageMaxWidth: 700,
      showPinchZoomAnimation: false,
      reloading: false,
      currentInitialSeats: null

    }
  },
  computed: {
    ticketTypeId () {
      if (!this.ticket) {
        return false // This will show all seats
      } else if (this.ticket.ticketType.appliesToSpecificSeats) {
        return this.ticket.ticketType.id
      } else {
        return null // This will only show seats that aren't set to a specific ticket type
      }
    },
    ticketTypeIds () {
      if (this.ticketTypeId === false) return false

      if (!this.ticketTypeId || !this.seatChartForShowing) return null

      // The the smallest subset of ticket type ids all sets of seats with this id has
      // Do this because this is the unit we are selecting over
      const matchingTicketTypeIds = _(this.seatChartForShowing.seatChart)
        .flatten()
        .filter(seat => seat.limitTicketTypes && _.includes(seat.ticketTypeIds, this.ticketTypeId))
        .sort(seat => seat.ticketTypeIds.length)
        .value()

      return matchingTicketTypeIds.length ? matchingTicketTypeIds[0].ticketTypeIds : null
    },
    showingId () {
      const showingId = this.$kiosk ? this.$route.params?.showing : this.$route.params?.showingId
      return (_.isNil(showingId) || showingId === '') ? null : Number(showingId)
    },
    seatsToSelect () { return this.order && this.order.countSeatsToSelect(this.order.showing, this.ticketTypeIds) },
    initialSelectedSeats () {
      // If currentInitialSeats exists and has items, use it
      if (this.currentInitialSeats && this.currentInitialSeats.length > 0) {
        return this.currentInitialSeats
      } else {
        return _.map(this.selectedSeats, 'name')
      }
    },
    selectedSeatsString () {
      const seatNames = this.currentSite.consumerConfig.showTicketFirstCheckoutFlow ? this.selectedSeats : this.selectedSeats.map(seat => seat.name)
      return seatNames.join(', ')
    },
    selectedSeatString () {
      if (!this.selectedSeats || this.selectedSeats.length < 1) return undefined

      const currentSeatIndex = this.selectedSeats.length - 1
      const { name = '', seatType = '' } = this.selectedSeats[currentSeatIndex]
      const formattedSeatType = seatType.replace(/-/g, ' ')
      return `${name}/${formattedSeatType}`
    },
    seatChart () {
      return this.showing?.screen?.seatChart || [[]]
    },
    seatPreferences () {
      return this.order?.user?.seatPreferences || { y_ratio: 0.5 }
    },
    isTicketPrintingDisabled () {
      return this.currentRegisterClient?.registerStation?.registerType?.kioskOptions?.disable_ticket_printing
    },
    topMargin () {
      if (this.$kiosk) {
        if (this.isTicketPrintingDisabled) {
          return this.$isLandscapeView() ? '130px' : '50px'
        } else {
          return this.$isLandscapeView() ? '80px' : undefined
        }
      } else if (this.$consumer && !this.checkoutData.showCheckoutFooter) {
        return undefined
      } else {
        if (!this.$isLandscapeView() && this.$q.screen.gt.xs) return '0px'
        if (this.$q.screen.gt.xs) return '80px'
        if (window._cordovaNative) return '200px'
        return '150px'
      }
    },
    loggedIn () {
      const user = this.$kiosk ? this.order.user : this.currentUser
      return user && user.isRemote
    },
    draftShowingTicketOrderItems () {
      return this.order.draftShowingTicketOrderItems(this.showingId)
    },
    draftShowingTicketOrderItemsWithSeatsAssigned () {
      return _(this.draftShowingTicketOrderItems).filter(orderItem => !!orderItem.ticket.seatName).value()
    },
    draftShowingTicketOrderItemsWithoutSeatsAssigned () {
      return _(this.draftShowingTicketOrderItems).filter(orderItem => !orderItem.ticket.seatName).value()
    },
    unassignedSelectedSeats () {
      return unassignedSelectedSeats(this.order, this.showingId, this.selectedSeats)
    },
    hasTicketSelectionError () {
      return !_.isEmpty(this.unassignedSelectedSeats) ||
          !_.isEmpty(this.draftShowingTicketOrderItemsWithoutSeatsAssigned)
    },
    canProceed () {
      if (this.saving) return

      if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) return this.selectionComplete

      if (this.hasSeatChartError) return false

      if (this.hasTicketSelectionError) return false

      return isTicketSelectionComplete(this.order, this.showingId, this.selectedSeats)
    },
    unableToProceedNextButtonLabel () {
      if (this.canProceed) return null

      if (this.showTicketSelection && !_.isEmpty(this.unassignedSelectedSeats)) {
        const numTicketsRequired = this.unassignedSelectedSeats.length
        return numTicketsRequired > 1 ? this.$t('seatChart.selectTicketsToContinue', { count: numTicketsRequired }) : this.$t('seatChart.selectTicketToContinue')
      }

      const numSeatsRequired = this.draftShowingTicketOrderItems - this.selectedSeats.length
      return numSeatsRequired > 1 ? this.$t('seatChart.selectSeatsToContinue', { count: numSeatsRequired }) : this.$t('seatChart.selectSeatToContinue')
    },
    thumbStyle () {
      return {
        backgroundColor: this.currentSite.primaryColor,
        borderRadius: '2px',
        height: '4px',
        opacity: '0.5'
      }
    }
  },
  watch: {
    showingId () {
      this.selectedSeats = this.checkoutData.selectedSeatsForShowingId(this.showingId)
    },
    async 'seatChartForShowing.id' () {
      this.showing.screen.seatChart = this.seatChartForShowing
      const mostRowOrColumnCount = Math.max(this.seatChartForShowing.seatChart.length, this.seatChartForShowing.seatChart[0].length)

      if (this.$q.screen.gt.xs) {
        this.autoZoom = this.$q.screen.gt.md || !this.$isLandscapeView() ? Math.round(mostRowOrColumnCount / 25) : Math.round(mostRowOrColumnCount / 14)
      } else {
        this.autoZoom = Math.round(mostRowOrColumnCount / 12)
      }
      this.maxScale = this.autoZoom + 1
      const seatChartCookies = Cookies.get(this.$constants.cookies.seatChartCookies)
      const seatChartCookiesSiteId = seatChartCookies?.siteId
      const hasSeatChartCookies = !!seatChartCookies && seatChartCookiesSiteId === this.currentSite.id
      if (!hasSeatChartCookies) {
        if (this.seatChartForShowing.loading) return

        this.showPinchZoomAnimation = true
        setTimeout(() => {
          this.showPinchZoomAnimation = false
          Cookies.set(this.$constants.cookies.seatChartCookies, { siteId: this.currentSite.id, showPinchZoomAnimation: true, type: this.$constants.cookies.type.consumerConsent, expires: 365 })
        }, 4000)
      }
      await this.$nextTick()
    },
    'checkoutData.showtimeChangeCount': {
      handler (newValue, oldValue) {
        // Ensure when showtime changes, we reload the resize chart
        // This is to ensure the seat chart is always the correct size
        if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) return
        if (newValue !== oldValue) {
          this.applyAutoScale = false
          this.reloading = true

          setTimeout(() => {
            this.reloading = false
            this.resizeChart()
          }, 400)
        }
      },
      immediate: true // Runs once when the component is created
    },
    selectedSeats: {
      async handler () {
        if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) return
        if (this.saving) return

        // When seat selection changes, look for order items with invalid assigned seats.
        _.each(this.draftShowingTicketOrderItemsWithSeatsAssigned, (orderItemWithSeatAssigned) => {
          if (!_.find(this.selectedSeats, { name: orderItemWithSeatAssigned.ticket.seatName })) {
            this.order.removeOrderItem(orderItemWithSeatAssigned)
          }
        })

        if (_.isEmpty(this.unassignedSelectedSeats)) {
          this.shouldReselectSeats = false
        } else {
          await this.showing.ensureLoaded()
          // Clone the showing so it doesn't get destroyed when ticket selection is closed.
          this.showingForTicketSelection = this.showing.clone()

          // If we have new unassigned seats
          if (this.applyAutoScale) {
            // auto zoom the seat chart first if seat chart view is too small
            this.closeTicketSelectionWindow()
          } else {
            // show the ticket selection window
            this.showTicketSelection = true
          }
        }
      },
      immediate: true,
      deep: true
    },
    draftShowingTicketOrderItemsWithoutSeatsAssigned: {
      handler: function () {
        if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) return
        _.each(this.draftShowingTicketOrderItemsWithoutSeatsAssigned, orderItem => {
          const seatName = getSeatNameForTicketType(this.order, this.showing.id, orderItem.ticket.ticketType, this.checkoutData.selectedSeatsForShowingId(this.showing.id))

          if (seatName) {
            orderItem.ticket.assignSeatName(seatName)
          } else if (!this.shouldReselectSeats) {
            this.order.removeOrderItem(orderItem)
          }
        })

        if (_.isEmpty(this.draftShowingTicketOrderItemsWithoutSeatsAssigned)) {
          this.closeTicketSelectionWindow()
        }
      },
      deep: true,
      immediate: true
    },
    'seatChartForShowing.loaded': {
      handler: async function () {
        if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) return
        if (!this.seatChartForShowing.loaded) return

        const validatedSelectedSeats = []

        _.each(this.draftShowingTicketOrderItemsWithSeatsAssigned, (orderItemWithSeatAssigned) => {
          const seatName = orderItemWithSeatAssigned.ticket.seatName
          const updatedSeatObject = this.seatChartForShowing.seatObject(seatName)

          if (updatedSeatObject.available) {
            validatedSelectedSeats.push(updatedSeatObject)
          } else {
            this.shouldReselectSeats = true
            orderItemWithSeatAssigned.ticket.removeSeatName()
          }
        })

        _.each(this.unassignedSelectedSeats, seatObject => {
          const seatName = seatObject.name
          const updatedSeatObject = this.seatChartForShowing.seatObject(seatName)

          if (updatedSeatObject.available) {
            validatedSelectedSeats.push(updatedSeatObject)
          }
        })

        this.selectedSeats = validatedSelectedSeats
      },
      immediate: true,
      deep: true
    }
  },
  models: {
    showing: {
      movie: 'default',
      screen: 'default',
      showingBadges: true,
      showings: true,
      showing: true,
      variables () {
        return {
          id: this.showingId,
          skip: _.isNil(this.showingId)
        }
      },
      immediate: true,
      force: true
    },
    seatChartForShowing: {
      variables () {
        return {
          showingId: this.showingId,
          orderId: this.order?.isRemote ? this.order.id : null,
          skip: _.isNil(this.showingId)
        }
      },
      immediate: true,
      force: true
    },
    showingsForDate: {
      movie: 'default',
      screen: 'default',
      variables () {
        return {
          date: this.currentSite.siteEffectiveDateForTime(this.showing?.time),
          movieId: this.showing?.movie?.id,
          siteIds: [this.currentSite.id],
          skip: !this.showing?.loaded
        }
      }
    }
  },
  mounted () {
    this.initializeChart()
    if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) {
      this.getInitialSelectedSeats()
    }
  },
  activated () {
    this.initializeChart()
    if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) {
      this.getInitialSelectedSeats()
    }
  },
  unmounted () {
    this.stopWatch && this.stopWatch()
  },
  methods: {
    handleSeatChartInput (input) {
      this.selectedSeats = input.selectedSeats
      this.selectionComplete = input.complete
      this.selectionDescription = input.description
    },
    async initializeChart () {
      this.stopWatch = watchEffect(() => {
        this.checkoutData.showLoading = false
        this.checkoutData.purchasingMembership = false

        this.checkoutData.stepTitle = this.guestCheckoutConfirmed || this.loggedInStatus || this.loggedIn || this.currentSite.consumerConfig.showTicketFirstCheckoutFlow ? this.$i18n.t('checkout.steps.seats') : this.$i18n.tc('user.account', 1)
        this.checkoutData.showMovieCard = true
        this.checkoutData.showCartControls = true
        this.checkoutData.showCheckoutFooter = ((this.loggedIn || this.guestCheckoutConfirmed) && !this.showTicketSelection) || this.currentSite.consumerConfig.showTicketFirstCheckoutFlow

        this.checkoutData.expandDefault = false
        this.checkoutData.expandConcessions = false
        this.checkoutData.expandTickets = true

        this.checkoutData.infoTitle = this.$i18n.t('checkout.infoTitles.seatsSelected')
        this.checkoutData.info = this.selectionDescription
        this.checkoutData.selectedSeats = this.selectedSeatsString
        this.checkoutData.showSubtotal = true
        this.checkoutData.showTotals = true

        this.checkoutData.showEmptyCartNextLabel = false
        this.checkoutData.canProceed = this.canProceed

        if (!this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) {
          this.checkoutData.sessionData[this.showingId] ||= {}
          this.checkoutData.sessionData[this.showingId].hasSeatChartError = this.hasSeatChartError
          this.checkoutData.sessionData[this.showingId].hasTicketSelectionError = this.hasTicketSelectionError
          this.checkoutData.sessionData[this.showingId].selectedSeats = this.selectedSeats

          this.checkoutData.unableToProceedNextButtonLabel = this.unableToProceedNextButtonLabel
          this.checkoutData.guestCheckoutConfirmed = this.guestCheckoutConfirmed
        }
      })

      await this.$nextTick()
      await this.showing.fetch(true)
      this.order.currentShowing = this.showing

      const ticketId = +this.$route.query?.ticketId
      const ticket = ticketId && _.find(this.order.showingTicketOrderItems(this.showing), orderItem => orderItem?.ticket?.id === ticketId)?.ticket

      if (ticket) {
        this.ticket = ticket
      } else {
        // Auto select the type of seat to select from the list remaining
        let firstOrderItemRequiringSeatSelection = null
        let firstOrderItemNotRequiringSeatSelection = null
        _.each(this.order.showingTicketOrderItems(this.showing), orderItem => {
          if (!orderItem.ticket?.seatName) {
            firstOrderItemRequiringSeatSelection ||= orderItem
          } else if (orderItem.ticket?.seatName) {
            firstOrderItemNotRequiringSeatSelection ||= orderItem
          }
        })

        if (firstOrderItemRequiringSeatSelection) {
          this.ticket = firstOrderItemRequiringSeatSelection.ticket
        } else if (firstOrderItemNotRequiringSeatSelection) {
          this.ticket = firstOrderItemNotRequiringSeatSelection.ticket
        }
      }

      await this.$nextTick()
      await this.seatChartForShowing.fetch(true)
      await this.resizeChart()

      // Run auto select routine
      if (this.currentSite.autoSelectSeats && this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) {
        this.$refs.seatChart.autoSelect()
      }
    },
    async resizeChart () {
      await this.$nextTick()
      const seatChartContainer = this.$refs.seatChartContainer
      const seatChart = this.$refs.seatChart

      if (!seatChart || !seatChartContainer) return

      const heightWithControl = this.showFullScreen
        ? window.innerHeight - 100
        : this.$q.screen.gt.xs ? seatChartContainer.clientHeight - 100 : seatChartContainer.clientHeight - 20
      const widthWithControl = this.showFullScreen
        ? window.innerWidth - 20
        : seatChartContainer.clientWidth

      const heightRatio = heightWithControl / seatChart.$refs['seat-chart-wrapper'].clientHeight
      const widthRatio = widthWithControl / seatChart.$refs['seat-chart-wrapper'].clientWidth
      let widthToFillHeight = heightRatio * widthWithControl

      // Fill screen on small phones and scroll
      const minWidth = Math.min(window.visualViewport.width, 400)
      widthToFillHeight = Math.max(widthToFillHeight, minWidth)

      const maxWidth = this.$isLandscapeView() ? window.visualViewport.width - 800 : window.visualViewport.width
      widthToFillHeight = Math.min(widthToFillHeight, maxWidth)

      if (widthToFillHeight >= widthWithControl) {
        this.pageMaxWidth = widthToFillHeight
      } else if (widthToFillHeight < widthWithControl) {
        this.pageMaxWidth = Math.min(widthWithControl, this.$el.scrollWidth)
      } else {
        this.pageMaxWidth = Math.min(window.innerWidth, 700)
      }

      if (heightRatio < 1 && (this.$isLandscapeView() || this.showFullScreenn)) {
        this.initialScale = heightRatio
        this.originX = widthWithControl / 2
        this.originY = 0
      } else if (widthRatio < 1 && this.showFullScreen) {
        this.initialScale = widthRatio
        this.originX = 0
        this.originY = heightWithControl / 2
      } else {
        this.initialScale = 1
        this.originX = 0
        this.originY = 0
      }

      this.currentScale = this.initialScale
      this.containerWidth = widthWithControl
      this.initialMinScale = Math.max(this.initialScale - 0.5, 0.1)
    },
    getInitialSelectedSeats () {
      this.currentInitialSeats = this.order && this.order.currentSelectedSeats(this.order.showing, this.ticketTypeIds)
    },
    toggleFullScreen (seats) {
      // Only update currentInitialSeats if seats exist and have items
      if (seats && seats.length > 0) {
        this.currentInitialSeats = this.currentSite.consumerConfig.showTicketFirstCheckoutFlow
          ? seats
          : seats.map(seat => seat.name)
      }

      this.showFullScreen = !this.showFullScreen
      const scaleAdjustment = this.showFullScreen ? 2 : 1

      this.maxScale = (this.autoZoom / scaleAdjustment) + 1
      this.$refs.zoomer.manualZoom(this.initialScale)

      this.resizeChart()
    },
    closeTicketSelectionWindow () {
      if (!_.isEmpty(this.unassignedSelectedSeats)) {
        _.each(this.unassignedSelectedSeats, seat => this.$refs.seatChart?.removeSelectedSeat(seat.name))
      }

      this.showingForTicketSelection = null
      this.showTicketSelection = false
    },
    next () {
      if (this.saving) return
      if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) {
        this.assignSeatsToTickets()
      } else {
        this.saveAssignedSeats()
      }
    },
    async saveAssignedSeats () {
      this.saving = true

      const { errors } = await this.order.save()

      if (errors && errors.length) {
        this.$mh.showErrors(errors)
        await this.seatChartForShowing.fetch(true)
        this.saving = false
      } else {
        this.saving = false
        this.$emit('next')
      }
    },
    async assignSeatsToTickets () {
      this.order.setSeatSelection(this.showing, [...this.selectedSeats].sort(sortAlphaNum), this.ticketTypeIds)
      const remainingOrderItemForSeatSelection = _.find(this.order.showingTicketOrderItems(this.showing), orderItem => !orderItem?.ticket?.seatName)
      if (remainingOrderItemForSeatSelection) {
        await this.seatChartForShowing.fetch(true)
        this.ticket = remainingOrderItemForSeatSelection.ticket
        this.selectedSeats = []
        this.$refs.seatChart?.clearSelection()
        await this.$nextTick()
        if (this.currentSite.autoSelectSeats) {
          this.$refs.seatChart?.autoSelect()
        }
        this.resizeChart()
        this.saving = false
        return
      }
      const { errors } = await this.order.save()
      if (errors && errors.length) {
        this.$mh.showErrors(errors)
        this.order.clearSeatSelection(this.showing)
        this.selectedSeats = []
        this.$refs.seatChart?.clearSelection()
        await this.seatChartForShowing.fetch(true)
        this.saving = false
      } else {
        this.saving = false
        this.$emit('next')
      }
    },
    selectMovie (movieUrlSlugOrId) {
      this.requestLeavePage(() => {
        this.$router.push(`/movie/${movieUrlSlugOrId}`)
      })
    },
    continueAsGuest () {
      this.checkoutData.guestCheckoutConfirmed = true
      this.guestCheckoutConfirmed = true
      this.resizeChart()
    },
    async logInUser (userId) {
      if (this.$kiosk) {
        if (userId === this.order.user?.id) {
        // User is already logged in and matches the current user, so we can skip
          return
        }
        const orderUser = this.order.setRelated('user', { id: userId })
        await orderUser.fetch(true)
      } else {
        await Model.configuration.validate()
        await Model.context.fetch(true)
      }
      this.loggedInStatus = true
      this.resizeChart()
    },
    computeUserOrderDatas () {
      _.each(_.flatten(this.userOrderDatas), oi => oi.destroy())

      if (this.user && !this.user?.loading && this.showing && !this.showing?.loading) {
        const result = this.order.initializeDataOrderForShowing(this.user, this.showing, this.checkoutData)

        // Add error checking
        if (!result || !Array.isArray(result)) {
          console.warn('Invalid result from initializeDataOrderForShowing:', result)
          this.userOrderDatas = []
          return
        }

        this.userOrderDatas = result
      } else {
        this.userOrderDatas = []
      }
    }
  },
  trackPage () {
    return {
      showingId: (this.order?.showing && this.order.showing.id) || undefined,
      // Append additional tracking metadata for the checkout flow
      ...this.checkoutData.trackingData
    }
  }
}
</script>
<style lang="scss" scoped>
.q-dialog.default-background > .q-dialog__inner {
  background-color: var(--q-background);
}

.attendance-bar{
  height: 6px;
  transition: all 0.3s ease-in-out;
  margin: -7px 1px 0;
  border-radius: 0 0 3px 3px;
  &:hover{
    height: 10px;
    margin: -11px 1px 0;
  }

  &.compact-button{
    border-radius: 0 0 5px 5px;
    margin: -6px 0px 0;
    &:hover{
      height: 10px;
      margin: -10px 0px 0;
    }
  }
  &.slider-button{
    margin: -9px 1px 0;
    &:hover{
      height: 9px;
      margin: -12px 0px 0;
    }
  }
}
</style>
